import App from './App.svelte';
import { setLocale } from './script/locale.js';

// Initialize Language
setLocale();

const app = new App({
	target: document.body,
	props: {
	},
});

export default app;